// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c79c0c96/" + chunkId + "." + __webpack_require__.h() + ".vc79c0c96.js";
};